// hooks/useBuildWithParams.ts (rename if needed)

import {
  DASHBOARD_TAB_ID_TO_SLUG,
  type DashboardTabId,
} from "@/constants/dashboardTabs";
import { ROUTES } from "@/routes/routes.config";

export const buildUrlWithParams = (
  baseUrl: string,
  params: Record<string, string | number>
): string => {
  const stringParams: Record<string, string> = Object.fromEntries(
    Object.entries(params).map(([key, value]) => [key, String(value)])
  );

  const query = new URLSearchParams(stringParams).toString();
  return `${baseUrl}?${query}`;
}; 

export function buildDashboardTabUrl(tabId: DashboardTabId): string {
  const slug = DASHBOARD_TAB_ID_TO_SLUG[tabId];
  return slug ? `${ROUTES.DASHBOARD}/${slug}` : "/dashboard";
}
